<template>
  <v-snackbar
    v-model="notification.show"
    top
    :timeout="notification.timeout"
    :color="notification.color"
  >
    <span>{{ notification.text }}</span>
    <v-btn dark text @click.native="close()">Fechar</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      notified: false,
      unsubscribe: null,
    };
  },
  computed: {
    ...mapGetters({
      notification: "notification",
    }),
  },
  watch: {
    notified(v) {
      if (v) {
        this.notified = false;
        this.fetchProductAccessRequests();
      }
    },
  },
  created() {
    const self = this;
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    fetchProductAccessRequests() {
      this.$store.dispatch("fetchAccessRequests").catch((err) => {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: err,
        });
      });
    },
    close() {
      this.$store.dispatch("clearNotification");
    },
  },
};
</script>

<style>
@media only screen and (min-width: 600px) {
  .v-snack__wrapper {
    border-bottom-left-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
}
</style>
